export default __webpack_public_path__ + "static/media/home1-banner4.df9ca11f.jpg";